import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CalculateIcon from '@mui/icons-material/Calculate';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { buildTabMaps, SideTabSection } from '../../components/SideTabs';

export const DEFAULT_TAB_VALUE = '1';

/**
 * Grouped by what an operator is doing: the batch itself, then the steps that
 * run against it. Values and `?tab=` params are unchanged from the previous
 * horizontal tab strip.
 */
export const feeBatchTabSections: SideTabSection[] = [
  {
    title: 'Batch',
    tabs: [
      { value: '1', param: 'feeBatch', label: 'Fee Batch', IconComponent: AccountBoxIcon },
      { value: '6', param: 'attachments', label: 'Attachments', IconComponent: AttachmentIcon },
    ],
  },
  {
    title: 'Processing',
    tabs: [
      { value: '2', param: 'feeCalculations', label: 'Fee Calculations', IconComponent: CalculateIcon },
      { value: '3', param: 'feeDeductions', label: 'Fee Deductions', IconComponent: RemoveCircleOutlineIcon },
      { value: '4', param: 'feeValidations', label: 'Fee Validation', IconComponent: FactCheckIcon },
      { value: '5', param: 'consolidateRequests', label: 'Consolidate Requests', IconComponent: MergeTypeIcon },
    ],
  },
];

export const {
  tabs: feeBatchTabs,
  mapTabParamToValue,
  mapTabValueToTabParam,
} = buildTabMaps(feeBatchTabSections, DEFAULT_TAB_VALUE);
